import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

function list({ direction = "received", status } = {}) {
  const params = { direction };
  if (status) {
    params.status = status;
  }
  return axios
    .get(apiEndpoint.fileShares, {
      headers: authHeader(),
      params,
    })
    .then((res) => res && res.data);
}

function shareExistingFile({ attachmentId, recipientUserIds, message, propertyId }) {
  const payload = {
    attachment_id: attachmentId,
    recipient_user_ids: recipientUserIds,
    message: message || null,
  };
  if (propertyId) {
    payload.property_id = propertyId;
  }
  return axios
    .post(apiEndpoint.fileShares, payload, { headers: authHeader() })
    .then((res) => res && res.data);
}

function uploadAndShare({ file, recipientUserIds, message, propertyId, onProgress }) {
  const form = new FormData();
  form.append("Attachment[file]", file);
  (recipientUserIds || []).forEach((id) => {
    form.append("recipient_user_ids[]", id);
  });
  if (message) {
    form.append("message", message);
  }
  if (propertyId) {
    form.append("property_id", propertyId);
  }
  return axios
    .post(apiEndpoint.fileShares, form, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded * 100) / evt.total));
        }
      },
    })
    .then((res) => res && res.data);
}

function revoke(id) {
  return axios
    .post(apiEndpointFunction.fileShareRevoke(id), {}, { headers: authHeader() })
    .then((res) => res && res.data);
}

function download(id) {
  return axios
    .get(apiEndpointFunction.fileShareDownload(id), { headers: authHeader() })
    .then((res) => res && res.data);
}

export const fileShareService = {
  list,
  shareExistingFile,
  uploadAndShare,
  revoke,
  download,
};
